import Layout from "components/layout";
import StudyPlanTaskGroup from "components/pages/tarefas/study_plan_task_group";
import Link from "next/link";
import Header from "components/pages/tarefas/header";

import { track } from "utils/tracker";

import { useStudyPlanTasks } from "hooks/study_plan_tasks";
import { useMounted } from "hooks/react";

export default function StudyPlanTasks(): JSX.Element {
  const {
    tasks,
    currentStepNumber,
    stepsCount,
    completedRate,
    isLoading,
    isFetching
  } = useStudyPlanTasks();

  useMounted(() => {
    track("Visited study plan tasks");
  });

  const currentTask = tasks.find(
    (task) => !task.ignoredTopicId && task.status !== "completed"
  );

  const taskGroups = tasks.reduce((groups, task) => {
    groups = groups || {};
    const label = groupKey(task);
    groups[label] = groups[label] || [];
    groups[label].push(task);
    return groups;
  }, {});

  taskGroups.current = (currentTask && [currentTask]) || [];

  function groupKey(task) {
    if (task.ignoredTopicId) return "ignored";

    if (task.status == "completed") {
      return "completed";
    } else if (JSON.stringify(task) !== JSON.stringify(currentTask)) {
      return "next";
    }
  }

  return (
    <Layout
      title="Tarefas do plano de estudos"
      description="Todas as aulas e exercícios que você precisa completar para se preparar para o ENEM e outros vestibulares!"
      canonical="/plano/tarefas"
    >
      <main className="!pb-[140px]">
        <div className="mb-10">
          <Header
            completedRate={completedRate}
            currentStepNumber={currentStepNumber}
            stepsCount={stepsCount}
            isLoading={isLoading}
            isFetching={isFetching}
          />
        </div>

        <StudyPlanTaskGroup
          groupKey="current"
          tasks={taskGroups["current"]}
          isLoading={isLoading}
        />

        <hr
          className="divider !mt-10 !mb-14 mx-20"
          style={{ width: "calc(100% - 160px)" }}
        />

        <div className="mt-8">
          <StudyPlanTaskGroup
            groupKey="next"
            tasks={taskGroups["next"]}
            opacity="opacity-60"
            isLoading={isLoading}
          />
        </div>

        <hr
          className="divider !mt-10 !mb-14 mx-20"
          style={{ width: "calc(100% - 160px)" }}
        />

        <div className="mt-8">
          <StudyPlanTaskGroup
            groupKey="ignored"
            tasks={taskGroups["ignored"]}
            opacity="opacity-40"
            isLoading={isLoading}
          />
        </div>

        <hr
          className="divider !mt-10 !mb-14 mx-20"
          style={{ width: "calc(100% - 160px)" }}
        />

        <div className="mt-8">
          <StudyPlanTaskGroup
            groupKey="completed"
            tasks={taskGroups["completed"]}
            opacity="opacity-40"
            isLoading={isLoading}
          />
        </div>
      </main>

      <Link href="/plano">
        <a className="btn btn-primary !fixed bottom-[68px] !shadow-lg explore mx-5 md:bottom-5">
          Explorar plano
        </a>
      </Link>

      <style jsx>
        {`
          a.explore {
            width: calc(100% - 40px);
          }

          @media (min-width: 1024px) {
            a.explore {
              width: calc(100% - 280px);
            }
          }
        `}
      </style>
    </Layout>
  );
}
